<div class="dialog-container">
  <div class="dialog-header">
    <img
      class="ee-value-img"
      [src]="images.EE_VALUE"
      [alt]="'EE_VALUE.EE_VALUE' | fallbackTranslate"
    />
    <div class="dialog-header-cross" (click)="cancel()">
      <img
        [src]="images.CLOSE_CIRCLE"
        class="img-32"
        [alt]="'EE_VALUE.CLOSE' | fallbackTranslate"
      />
    </div>
  </div>
  <div class="dialog-body">
    <div class="ee-logo-container">
      <div class="ee-logo">
        <img [src]="images.EE_LOGO" [alt]="'EE_VALUE.EE_LOGO' | fallbackTranslate" />
      </div>
    </div>
    <div class="ee-value-description">
      {{ 'EE_VALUE.HELPS_YOU_EARN' | fallbackTranslate }}
      <span class="bold-text m-r-5 m-l-5"
        >{{ Currency }} {{ grandEaring }}
      </span>
      {{ 'EE_VALUE.EXTRA_YESTERDAY' | fallbackTranslate }}
    </div>
    <div>
      <div
        class="row-parent"
        *ngFor="let rowData of eeValueData"
        [ngStyle]="{ 'border-left-color': rowData.border_color }"
      >
        <div class="row-image">
          <img class="m-r-5" [src]="rowData.img_url" [alt]="'EE_VALUE.ICON' | fallbackTranslate" />
        </div>
        <div class="content">
          <div class="row-title">{{ rowData.title }}</div>
          <div class="row-description">{{ rowData.description }}</div>
        </div>
        <div class="ee-amt">{{ Currency }} {{ rowData.total_amount }}</div>
      </div>
    </div>
  </div>
</div>